import LiteYouTubeEmbed from './LiteYouTubeEmbed'

export default LiteYouTubeEmbed
